import { defineMessages } from 'react-intl'

const messages = defineMessages({
  shipsTo: {
    id: 'Checkout.shipsTo',
    defaultMessage: 'Levereras till',
  },
  sorryMoDeliveryOptionsAvailable: {
    id: 'Checkout.sorryMoDeliveryOptionsAvailable',
    defaultMessage: 'Sorry! Inga leveranssätt tillgängliga.',
  },
  continueToPayment: {
    id: 'Checkout.continueToPayment',
    defaultMessage: 'Till betalning',
  },
  subtotal: {
    id: 'Checkout.subtotal',
    defaultMessage: 'Delsumma',
  },
  totalDiscounts: {
    id: 'Checkout.totalDiscounts',
    defaultMessage: 'Total rabatt',
  },
  taxDeducted: {
    id: 'Checkout.taxDeducted',
    defaultMessage: 'Tax deducted',
  },
  shipping: {
    id: 'Checkout.shipping',
    defaultMessage: 'Leverans',
  },
  shippingTo: {
    id: 'Checkout.shippingTo',
    defaultMessage: 'Leverans till',
  },
  edit: {
    id: 'Checkout.edit',
    defaultMessage: 'Redigera',
  },
  grandTotal: {
    id: 'Checkout.grandTotal',
    defaultMessage: 'Total',
  },
  unknownPaymentResponse: {
    id: 'Checkout.unknownPaymentResponse',
    defaultMessage: 'Unknown payment response',
  },
  clickToCompleteYourPurchase: {
    id: 'Checkout.clickToCompleteYourPurchase',
    defaultMessage:
      'Click to complete your purchase at the merchant. You will then be redirected back to the shop for a receipt.',
  },
  sorrySomethingWentWrongWhenPlacingYourOrder: {
    id: 'Checkout.sorrySomethingWentWrongWhenPlacingYourOrder',
    defaultMessage: 'Något gick fel vid beställningen.',
  },
  pleaseTryAgainOrUseADifferentPaymentMethod: {
    id: 'Checkout.pleaseTryAgainOrUseADifferentPaymentMethod',
    defaultMessage: 'Försök igen eller testa en annan betalmetod.',
  },
  confirmYourPostalCode: {
    id: 'Checkout.confirmYourPostalCode',
    defaultMessage: 'Bekräfta ditt postnummer',
  },
  thePostalCodeYouHaveProvidedDoesNotMatchKlarna: {
    id: 'Checkout.thePostalCodeYouHaveProvidedDoesNotMatchKlarna',
    defaultMessage:
      'Postnumret du angett till Klarna stämmer inte överrens med postnumret ovan.',
  },
  thisMightAffectYourDeliveryOption: {
    id: 'Checkout.thisMightAffectYourDeliveryOption',
    defaultMessage: 'Detta kan påverka dina leveransval.',
  },
  wouldYouLikeDeliveryToYourKlarnaPostalCodeInstead: {
    id: 'Checkout.wouldYouLikeDeliveryToYourKlarnaPostalCodeInstead',
    defaultMessage:
      'Vill du välja leverans och använda postnumret från Klarna istället?',
  },
  yesIWantToChooseDeliveryMethodAgain: {
    id: 'Checkout.yesIWantToChooseDeliveryMethodAgain',
    defaultMessage: 'Ja, jag vill välja nytt leveransalternativ igen',
  },
  noIllChangeMyKlarnaPostalCode: {
    id: 'Checkout.noIllChangeMyKlarnaPostalCode',
    defaultMessage: 'Nej, jag ändrar mitt postnummer i Klarna',
  },
  productImage: {
    id: 'Checkout.productImage',
    defaultMessage: 'Produktbild',
  },
  homeDelivery: {
    id: 'Checkout.homeDelivery',
    defaultMessage: 'Hemleverans',
  },
  followYourDeliveryInReal: {
    id: 'Checkout.followYourDeliveryInReal',
    defaultMessage:
      'Follow your delivery in real time and choose if the package should be left outside your door.',
  },
  state: {
    id: 'Checkout.state',
    defaultMessage: 'State',
  },
  enterAValidState: {
    id: 'Checkout.enterAValidState',
    defaultMessage: 'Enter a valid state',
  },
  postalCode: {
    id: 'Checkout.postalCode',
    defaultMessage: 'Postnummer',
  },
  enterAZipPostalCode: {
    id: 'Checkout.enterAZipPostalCode',
    defaultMessage: 'Ange postnummer',
  },
  city: {
    id: 'Checkout.city',
    defaultMessage: 'Stad',
  },
  enterACity: {
    id: 'Checkout.enterACity',
    defaultMessage: 'Ange stad',
  },
  phoneNumber: {
    id: 'Checkout.phoneNumber',
    defaultMessage: 'Telefonummer',
  },
  enterAValidPhoneNumber: {
    id: 'Checkout.enterAValidPhoneNumber',
    defaultMessage: 'Ange ett giltigt telefonnummer',
  },
  enterAValidEMail: {
    id: 'Checkout.enterAValidEMail',
    defaultMessage: 'Ange en giltig e-mail',
  },
  delivery: {
    id: 'Checkout.delivery',
    defaultMessage: 'Leverans',
  },
  deliveryToANearbyPickupPoint: {
    id: 'Checkout.deliveryToANearbyPickupPoint',
    defaultMessage: 'Leverans till närliggande ombud', // TODO ' in {timeSpan} business days'?
  },
  email: {
    id: 'Checkout.email',
    defaultMessage: 'E-mail',
  },
  postalCodeCountry: {
    id: 'Checkout.postalCodeCountry',
    defaultMessage: 'Postnummer & land',
  },
  address: {
    id: 'Checkout.address',
    defaultMessage: 'Adress',
  },
  contactInformation: {
    id: 'Checkout.contactInformation',
    defaultMessage: 'Kontaktinformation',
  },
  firstName: {
    id: 'Checkout.firstName',
    defaultMessage: 'Namn',
  },
  enterAFirstName: {
    id: 'Checkout.enterAFirstName',
    defaultMessage: 'Ange namn',
  },
  lastName: {
    id: 'Checkout.lastName',
    defaultMessage: 'Efternamn',
  },
  enterALastName: {
    id: 'Checkout.enterALastName',
    defaultMessage: 'Ange efternamn',
  },
  enterAnAddress: {
    id: 'Checkout.enterAnAddress',
    defaultMessage: 'Ange adress',
  },
  extraAddress: {
    id: 'Checkout.extraAddress',
    defaultMessage: 'Extra adress',
  },
  shippingMethod: {
    id: 'Checkout.shippingMethod',
    defaultMessage: 'Leveransmetod',
  },
  rememberMeOnThisDevice: {
    id: 'Checkout.rememberMeOnThisDevice',
    defaultMessage: 'Kom ihåg mig på den här enheten',
  },
  iAccept: {
    id: 'Checkout.iAccept',
    defaultMessage: 'Jag godkänner',
  },
  theGeneralTermsConditionsAndPrivacyPolicy: {
    id: 'Checkout.theGeneralTermsConditionsAndPrivacyPolicy',
    defaultMessage: 'Allmända villkor & Integritetspolicy',
  },
  youMustAccept: {
    id: 'Checkout.youMustAccept',
    defaultMessage: 'Du måste godkänna',
  },
  getDeliveryOptions: {
    id: 'Checkout.getDeliveryOptions',
    defaultMessage: 'Visa leveransalternativ',
  },
  pleaseEnterAtLeastTwoLetters: {
    id: 'Checkout.pleaseEnterAtLeastTwoLetters',
    defaultMessage: 'Du behöver ange minst 2 bokstäver',
  },
  invalidCode: {
    id: 'Checkout.invalidCode',
    defaultMessage: 'Ogiltig kod',
  },
  discountSuccessfullyAdded: {
    id: 'Checkout.discountSuccessfullyAdded',
    defaultMessage: 'Rabatt tillagd!',
  },
  giftCardOrDiscountCode: {
    id: 'Checkout.giftCardOrDiscountCode',
    defaultMessage: 'Presentkort eller rabattkod',
  },
  addGiftCardOrDiscountCode: {
    id: 'Checkout.addGiftCardOrDiscountCode',
    defaultMessage: 'Har du ett presentkort? Lägg till din kod',
  },
  finalDetails: {
    id: 'Checkout.finalDetails',
    defaultMessage: 'Extra',
  },
  add: {
    id: 'Checkout.add',
    defaultMessage: 'Add',
  },
  removeOneItem: {
    id: 'Checkout.removeOneItem',
    defaultMessage: 'Remove 1 item',
  },
  addOneItem: {
    id: 'Checkout.addOneItem',
    defaultMessage: 'Add 1 item',
  },
  weveAlwaysCared: {
    id: 'Checkout.weveAlwaysCared',
    defaultMessage:
      'We’ve always cared for your jeans. Now we take care of you.',
  },
  enterYourEmail: {
    id: 'Checkout.enterYourEmail',
    defaultMessage: 'Enter your e-mail',
  },
  checkout: {
    id: 'Checkout.checkout',
    defaultMessage: 'Checkout',
  },
  checkoutAsGuest: {
    id: 'Checkout.checkoutAsGuest',
    defaultMessage: 'Checkout as guest',
  },
  yourDetails: {
    id: 'Checkout.yourDetails',
    defaultMessage: 'Din information',
  },
  continueShopping: {
    id: 'Checkout.continueShopping',
    defaultMessage: 'Fortsätt handla',
  },
  showOrderSummary: {
    id: 'Checkout.showOrderSummary',
    defaultMessage: 'Visa översikt',
  },
  orderSummary: {
    id: 'Checkout.orderSummary',
    defaultMessage: 'Översikt',
  },
  payment: {
    id: 'Checkout.payment',
    defaultMessage: 'Betalning',
  },
  free: {
    id: 'Checkout.free',
    defaultMessage: 'Gratis',
  },
  joinOurNewsletter: {
    id: 'Checkout.joinOurNewsletter',
    defaultMessage: 'Anmäl dig till vårt nyhetsbrev',
  },
})

export default messages
